import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import * as redux from 'redux/selectors';
import { PageLayout, LifebookNav } from 'components';
import * as Child from '.';
import { ResendExitCare } from './components/ChildAdmin';

export default function ManageChild() {
	const { childId } = useParams();
	const user = useSelector((state) => state.user.user);
	const isCaseManager = user.type === 'case-manager';
	const child = useSelector((state) => state.lifebooks.child);
	const casaPermissions = useSelector((state) => state.casa.casaPermissions);
	const casaUserPermissions = useSelector((state) => state.casaUserPermissions);

	const location = useLocation();
	const isArchive = location.pathname?.includes('archive');

	const {
		pageTitle,
		state: basicState,
		values: basicValues,
		initialize: basicInitialize,
	} = Child.useManageChildBasicState();
	const imageState = !isArchive ? Child.useManageChildImageState() : '';
	const swState = !isArchive ? Child.useManageChildSWState() : '';
	const homeState = !isArchive ? Child.useManageChildHomeState() : '';
	const cswState = !isArchive ? Child.useManageChildCSWState() : '';
	const schoolState = !isArchive ? Child.useManageChildSchoolState() : '';
	const codeState = !isArchive ? Child.useManageChildCodeState() : '';
	const siblingState = !isArchive ? Child.useManageChildSiblingsState() : '';
	const siblingsState = siblingState?.selectorState;
	const siblingInitialize = siblingState?.siblingInitialize;

	const { house: { id: houseId } = {} } = useSelector(redux.getLifebooksChild);
	const houseHash = useSelector(redux.getHomesHouseHash);
	const rps = houseHash[houseId]?.resourceParents;

	const { ownershipCodeVerified } = codeState;

	let permissions;

	if (user.type === 'casauser') {
		if (user.role === 'admin') {
			permissions = casaPermissions;
		} else {
			permissions = casaUserPermissions;
		}
	}

	const getBody = () => {
		return {
			basicValues,
			basicInitialize,
			imageState,
			swState,
			siblingsState,
			homeState,
			cswState,
			codeState,
			schoolState,
			siblingInitialize,
		};
	};

	let writeProfile = true;

	if (user.type === 'casauser' && child.agencyId) {
		if (!permissions?.basic_write_profile && !permissions?.mgmt_write_profile) {
			writeProfile = false;
		}
	}

	if (user.role === 'social-worker' && !user.privileged) {
		writeProfile = false;
	}

	const seeContributor =
		user.type === 'agencyuser' || user.type === 'casauser' || !isArchive;

	const buttonArray = Child.useManageChildButtons({ getBody });

	return (
		<>
			<PageLayout
				title={pageTitle}
				buttonArray={writeProfile ? [buttonArray] : null}
				footer={childId && <LifebookNav />}
				showChildContext={isCaseManager}
				align='left'>
				<Child.ChildImage {...{ ...imageState, ownershipCodeVerified }} />
				{!isCaseManager && <Child.ChildCode {...codeState} />}
				<Child.ChildBasicInfo
					state={basicState}
					school={schoolState}
					ownershipCodeVerified={ownershipCodeVerified}
				/>
				{!ownershipCodeVerified && (
					<>
						{!isCaseManager && (
							<>
								<Child.ChildSiblings selectorListState={siblingsState} />
								{user.type !== 'casauser' && (
									<>
										<Child.ChildCSW state={cswState} />
										<Child.ChildHome selectorListState={homeState} />
										<Child.ChildResourceParents parents={rps} />
										<Child.ChildSocialWorker selectorListState={swState} />
										<Child.ChildCasa />
									</>
								)}
								{!isArchive && seeContributor && childId && (
									<Child.ChildContributor />
								)}
							</>
						)}
						<Child.ChildSchool
							key={`managecChildSchool-${childId}`}
							{...schoolState}
						/>
					</>
				)}
				{!isCaseManager && user.type !== 'casauser' && !isArchive && (
					<Child.ChildAudit />
				)}
				<Child.ChildAdmin />
				{user.role === 'admin' && isArchive && <ResendExitCare />}
			</PageLayout>
		</>
	);
}
